// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@ces/App/Store/Reducers";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import * as React from "react";

interface Props extends WidgetProps, HasCategoryContext {}

export interface CategoryImageStyles {
    image?: LazyImageProps;
}

export const categoryImageStyles: CategoryImageStyles = {};

const CategoryImage = ({ category }: Props) => {
    const isMobileScreen = useAppSelector(
        (state: ApplicationState) => (state as CustomAppState).xCommon.isMobileScreen,
    );
    // XNG-Change: fallback
    const categoryImageSrc = isMobileScreen
        ? category?.smallImagePath || category?.largeImagePath
        : category?.largeImagePath || category?.smallImagePath;

    if (!category || !categoryImageSrc) {
        return null;
    }

    return (
        <LazyImage
            altText={category.imageAltText}
            {...categoryImageStyles.image}
            data-test-selector="categoryImagePath"
            src={categoryImageSrc}
        />
    );
};

const widgetModule: WidgetModule = {
    component: withCategory(CategoryImage),
    definition: {
        group: "Category Details",
        icon: "image",
        allowedContexts: ["CategoryDetailsPage", "ProductDetailsPage", "ProductListPage"],
    },
};

export default widgetModule;
